import { parseAsNumber } from './parser';
import { Config } from './types';

const config: Config = {
  ILLION_INTEGRATION_PARTNER_CODE: 'FB604B05-F496-2C7F-58CF-7E57AE4FAF56',
  ENVIRONMENT: 'production',
  AUTH_FROM_EMAIL: 'Expertli <support@expertli.com>',
  AUTH_SMTP_SERVER: process.env.AUTH_SMTP_SERVER,
  AUTH_GITHUB_CLIENT_ID: process.env.AUTH_GITHUB_CLIENT_ID,
  AUTH_GITHUB_CLIENT_SECRET: process.env.AUTH_GITHUB_CLIENT_SECRET,
  AUTH_GOOGLE_CLIENT_ID: process.env.AUTH_GOOGLE_CLIENT_ID,
  AUTH_GOOGLE_CLIENT_SECRET: process.env.AUTH_GOOGLE_CLIENT_SECRET,
  AUTH_AZURE_AD_CLIENT_ID: process.env.AUTH_AZURE_AD_CLIENT_ID,
  AUTH_AZURE_AD_CLIENT_SECRET: process.env.AUTH_AZURE_AD_CLIENT_SECRET,
  AUTH_ATLASSIAN_CLIENT_ID: process.env.AUTH_ATLASSIAN_CLIENT_ID,
  AUTH_ATLASSIAN_CLIENT_SECRET: process.env.AUTH_ATLASSIAN_CLIENT_SECRET,

  NEXTAUTH_URL: process.env.NEXTAUTH_URL || process.env.NEXT_PUBLIC_VERCEL_URL,
  NEXTAUTH_SECRET: process.env.NEXTAUTH_SECRET,
  NEXT_PUBLIC_MUNCHER_URL: process.env.NEXT_PUBLIC_MUNCHER_URL as string,
  LOGGING_DISABLED: false,
  NEXT_PUBLIC_LOG_LEVEL: (process.env.NEXT_PUBLIC_LOG_LEVEL as string) || 'warn',
  DATADOG_API_KEY: process.env.DATADOG_API_KEY as string,
  DATADOG_CLIENT_TOKEN: 'pub2ef69633e55598e4a789b7026abafa1f',

  PDFTRON_LICENSE_KEY:
    process.env.NEXT_PUBLIC_PDFTRON_LICENSE_KEY ||
    'demo:1656927007959:7a49809d0300000000983b9e374127e8bece97c4308c4cee96ed36127b',

  POSTMARK_API_TOKEN: process.env.POSTMARK_API_TOKEN,
  QUICKLI_BEARER_TOKEN: process.env.QUICKLI_BEARER_TOKEN || '',
  QUICKLI_EXPERTLI_SECRET:
    process.env.QUICKLI_EXPERTLI_SECRET || '0734b213-b332-467f-aad0-56b028845259',

  CLICKSEND_USERNAME: (process.env.CLICKSEND_USERNAME as string) || 'app@expertli.com',
  CLICKSEND_API_TOKEN: process.env.CLICKSEND_API_TOKEN as string,

  SUPABASE_URL: process.env.SUPABASE_URL as string,
  SUPABASE_KEY: process.env.SUPABASE_KEY as string,
  TWILIO_ACCOUNT_SID: process.env.TWILIO_ACCOUNT_SID as string,
  TWILIO_API_KEY: process.env.TWILIO_API_KEY as string,
  TWILIO_API_SECRET: process.env.TWILIO_API_SECRET as string,
  TWILIO_AUTH_TOKEN: process.env.TWILIO_AUTH_TOKEN as string,
  NEXT_PUBLIC_EXPERTLI_URL: process.env.NEXT_PUBLIC_EXPERTLI_URL || 'https://app.expertli.com',
  NEXT_PUBLIC_EXPERTLI_API_URL:
    process.env.NEXT_PUBLIC_EXPERTLI_API_URL || 'https://api.expertli.com',
  EXPERTLI_API_KEY: process.env.EXPERTLI_API_KEY || 'some-secret-value',
  NEXT_PUBLIC_TWILIO_LOG_LEVEL: (process.env.NEXT_PUBLIC_TWILIO_LOG_LEVEL || 'warn') as string,
  NEXT_PUBLIC_GTM_CONTAINER_ID: 'GTM-PLN3FQT',
  NEXT_PUBLIC_USER_PRIVACY_VERSION: (process.env.NEXT_PUBLIC_USER_PRIVACY_VERSION ||
    '2022-06-06') as string,

  NEXT_PUBLIC_FEATURE_LINK_ACCOUNTS_ENABLED: false,

  NEXT_PUBLIC_FEATURE_UNDO_ENABLED: false,
  GOOGLE_MAPS_API_KEY: 'AIzaSyAXMUpMKrHLJi74Nlub2xjL45LGfT1iDkc',

  WORKSPACE_SESSION_IDLE_TIMEOUT: parseAsNumber(
    process.env.NEXT_PUBLIC_WORKSPACE_SESSION_IDLE_TIMEOUT,
    60 * 15
  ), // 15 minutes default
  WORKSPACE_SESSION_IDLE_LOGOUT_TIMEOUT: parseAsNumber(
    process.env.NEXT_PUBLIC_WORKSPACE_SESSION_IDLE_LOGOUT_TIMEOUT,
    60 * 2
  ), // 2 minutes to make yourself active again

  USER_SESSION_IDLE_TIMEOUT: parseAsNumber(
    process.env.NEXT_PUBLIC_USER_SESSION_IDLE_TIMEOUT,
    60 * 60 * 2
  ), // 2 hours
  USER_SESSION_IDLE_LOGOUT_TIMEOUT: parseAsNumber(
    process.env.NEXT_PUBLIC_USER_SESSION_IDLE_LOGOUT_TIMEOUT,
    60 * 2
  ), // 2 minutes

  VERSION: `v1.0.0-${process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA.substring(0, 7)}`,
};

export default config;
